import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { isUserLoggedIn } from '../../Helpers';

// eslint-disable-next-line import/prefer-default-export
export const CreateSelectItems = ({ handleMenuClick, t }) => {
  const menuData = [
    { value: t('common:tournament_current'), id: '1', login: '0', slug: '' },
    { value: t('common:tournament_calendar'), id: '2', login: '0', slug: 'calendar' },
    { value: t('common:tournament_past'), id: '3', login: '0', slug: 'past'},
    { value: t('common:tournament_about'), id: '4', login: '0', slug: 'about'},
    { value: t('common:tournament_rules'), id: '5', login: '0', slug: 'rules'},
  ];

  return (
    // eslint-disable-next-line no-unused-vars
    menuData.map((e, key) => (
      <NavLink
        className={`menu${e.id} m-top-nav-item ${!isUserLoggedIn() && e.login === '1' ? ' is-hidden' : ''}`}
        to={`../tournaments/${e.slug}#tournamentsNav`}
        id={e.id}
        onClick={handleMenuClick}
      >
        {e.value}
      </NavLink>
    ))
  );
};

CreateSelectItems.propTypes = {
  t: PropTypes.func.isRequired,
  handleMenuClick: PropTypes.func.isRequired,
};
